import { deleteRequest, getRequest, postRequest, putRequest } from './http';
import userStorage from 'utils/user/userStorage';
import { environmentVariables } from 'utils/environmentVariables';

export async function apiGetRequest(url: string, appendParameters?: string) {
  const headers = generateApiRequestHeaders();
  return getRequest(buildUrl(url, appendParameters), headers);
}

export async function apiPostRequest(
  url: string,
  body?: Record<string, unknown>,
  appendParameters?: string | undefined
) {
  const headers = generateApiRequestHeaders();
  return postRequest(buildUrl(url, appendParameters), body || {}, headers);
}

export async function apiPutRequest(
  url: string,
  body?: Record<string, unknown>,
  appendParameters?: string
) {
  const headers = generateApiRequestHeaders();
  return putRequest(buildUrl(url, appendParameters), body || {}, headers);
}

export async function apiDeleteRequest(
  url: string,
  body?: Record<string, unknown>,
  appendParameters?: string
) {
  const headers = generateApiRequestHeaders();
  return deleteRequest(buildUrl(url, appendParameters), body || {}, headers);
}

function buildUrl(url: string, appendParameters: string | undefined): string {
  const host = `${environmentVariables.REACT_APP_API_HOST}/api/`;
  const applicationIdParameter = `application=${environmentVariables.REACT_APP_APPLICATION_ID}`;
  appendParameters = appendParameters ? `&${appendParameters}` : '';
  return `${host}${url}?${applicationIdParameter}${appendParameters}`;
}

export function generateApiRequestHeaders() {
  const token = userStorage.getToken();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  };

  const appId = environmentVariables.REACT_APP_APPLICATION_ID;

  if (appId) {
    headers.Application = appId;
  }
  return headers;
}
